export default {
    general: {
        required: 'This field is required',
        email: 'Please enter a valid email address',
        phoneNumber: 'Please enter a valid phone number',
        errorOccurred: 'An error occurred',
        maxLength: 'Length should not exceed {0} characters',
        minLength: 'Length should be at least {0} characters',
        range: 'Allowed range is between {0} and {0}',
        integer: 'Only integers allowed',
        numeric: 'Value must be numeric',
        length: 'Length must be {0}',
        id: 'Personal ID is limited to numbers, letters and dashes',
        name: 'Name can only contain characters',
        max: 'Maximum value is {0}',
        min: 'Minimum value is {0}',
        mustContainDigits: 'Must contain digits',
        mustContainLowercaseCharacters: 'Must contain lowercase characters',
        mustContainUppercaseCharacters: 'Must contain uppercase characters',
    },

    password: {
        length: 'Password length should be at least 6 characters long',
        noMatch: 'Passwords entered do not match each other',
    },

    dateTime: {
        periodNegative: 'End date must be before start date',
        maxDays: 'Maximum days allowed:'
    },

    more: {
        someOfTheFieldsContainErrors: 'Some of the fields contain errors',
        generalError: 'An error occurred'
    },

    login: {
        credentialsError: 'Couldn\'t log in. Check your email and password and try again.'
    }

};
